import React, { useEffect, useState } from "react";
import {
  ActionButton,
  ButtonsContainer,
  PlateInfo,
} from "./VehicleModalStyles";
import { TextField } from "@mui/material";
import { formatIsoToBrDatetime, toReais } from "../../../../utils/functions";
import { Ticket } from "../../../../types/carWashing.types";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { activateMachine } from "../../../../services/machineService";
import { useUnit } from "effector-react";
import { UserStore } from "../../../../stores/UserStore/UserStore";
import { toast } from "react-toastify";
import { AppError } from "../../../../services/classes";
import { editOrder } from "../../../../services/orderService";

interface Props {
  ticket: Ticket;
  numberOfMachines: number;
  updateList: () => void;
  updateTickets: (ticket: Ticket) => void;
}

const TicketCard: React.FC<Props> = ({
  ticket,
  numberOfMachines,
  updateList,
  updateTickets,
}: Props) => {
  const { station } = useUnit(UserStore);

  const handleActivate = (machine: string) => {
    setLoading(true);

    const payload = {
      id: machine,
      washingType: ticket.washingType.washingId === "L4" ? (station !== "Z7" && station !== "Z1" ? "L3" : ticket.washingType.washingId) : ticket.washingType.washingId,
      stationCode: station || "",
    };

    activateMachine(payload)
      .then(() => {
        handleConsume();
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleConsume = () => {
    editOrder(ticket.id, false, station || "")
      .then((ticket) => {
        updateTickets(ticket);
        toast.success("Ticket consumido!");
        updateList();
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PlateInfo $used={!ticket.available}>
      {ticket.user ? (
        <TextField
          fullWidth
          label="Nome do cliente"
          variant="outlined"
          value={ticket.user.full_name}
          size="small"
        />
      ) : null}
      <TextField
        fullWidth
        label="Lavação"
        variant="outlined"
        value={`${ticket.washingType?.name} - ${toReais(
          ticket?.washingType?.price
        )}`}
        size="small"
      />
      <TextField
        fullWidth
        label="Disponível"
        variant="outlined"
        value={ticket.available ? "Sim" : "Não"}
        size="small"
      />
      <TextField
        fullWidth
        label="Adquirido em"
        variant="outlined"
        value={formatIsoToBrDatetime(ticket.createdAt)}
        size="small"
      />
      {ticket.available && (
        <>
          {/* {!isValidTicket ? (
            <></>
          ) : ( */}
          <ButtonsContainer>
            <ActionButton onClick={() => handleActivate("mach1")}>Acionar 1</ActionButton>
            {numberOfMachines > 1 && (
              <ActionButton onClick={() => handleActivate("mach2")}>Acionar 2</ActionButton>
            )}
          </ButtonsContainer>
          {/* )} */}
          <ButtonsContainer>
            <ActionButton onClick={handleConsume}>Consumir</ActionButton>
          </ButtonsContainer>
        </>
      )}
      {!ticket.available && (
        <TextField
          fullWidth
          label="Consumido em"
          variant="outlined"
          value={formatIsoToBrDatetime(ticket.updatedAt)}
          size="small"
        />
      )}
    </PlateInfo>
  );
};

export default TicketCard;
